import {axiosFormDataInstance, axiosInstance} from "./axiosConfig";


export const listTeams = async (page=1, perPage=10, search='') => {
    let url = '/teams?page='+page+'&per_page='+perPage;
    if(search !== ''){
        url = url+'&search='+search;
    }
    return axiosInstance.get(url);
};


export const deleteTeam = async (id) => {
    return axiosInstance.delete('/teams/' + id);
};


export const createTeam = async (name, managers, members, areas ) => {
    return axiosInstance.post('/teams', {name, managers, members, areas });
};

export const updateTeam = async (id, name, managers, members, areas ) => {
    return axiosInstance.put('/teams/' + id, {name, managers, members, areas });
};

export const showTeam = async (id) => {
    return axiosInstance.get('/teams/' + id);
};

export const setSetting = async (key,value) => {
    return axiosInstance.post('/settings/set', {key,value});
};

export const getSettings = async (id) => {
    return axiosInstance.get('/settings/get');
};

export const addSimContractImage = async (image) => {
    return axiosInstance.post('/settings/add-sim-contract-image', {image});
};




export const getAllStates = async (cityId, page=1, per_page=10, search='') => {
    let url = '/geo/city/' + cityId + '/states?page=' + page + '&per_page=' + per_page;
    if (search !== '') {
        url = url + '&search=' + search;
    }
    return axiosInstance.get(url);
}

export const addCountryData = async (country, city, states) => {
    return axiosInstance.post('/geo/add-country-data', {country, city, states});
};

export const addCityData = async (country, city, states) => {
    return axiosInstance.post('/geo/add-city-data', {country, city, states});
};

